import React from 'react';

const NotificationTypeGroupFormModal = React.lazy(() => import('../components/FormModal'));
const notificationTypeGroupModalRegistry = {
    notification_notificationTypeGroupId: NotificationTypeGroupFormModal
};
export default notificationTypeGroupModalRegistry;
